import React from 'react';

import * as S from './styles';
import { IconChevronDown, IconChevronUp } from '@prisjakt/ui/icon';

interface IExpandButton {
  expanded: boolean;
  onClick: () => void;
  title?: string;
  featured: boolean;
}

const ExpandButton: React.FC<IExpandButton> = ({
  expanded,
  onClick,
  title,
  featured,
}) => {
  const color = featured ? 'maybeBlue700' : 'base500';

  return (
    <S.ExpandButton
      type="button"
      aria-label={title}
      onClick={onClick}
      expanded={expanded}
      data-test="ExpandButton"
    >
      {expanded ? (
        <IconChevronUp color={color} size={30} />
      ) : (
        <IconChevronDown color={color} size={30} />
      )}
    </S.ExpandButton>
  );
};

export default ExpandButton;
